'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.changeWonItemsPage = exports.fetchWonItemsIfNeeded = exports.areWonItemsLoaded = exports.getWonItemsPageSize = exports.getWonItemsPage = exports.getWonItems = exports.getTotalWonItemsCount = exports.CHANGE_WON_ITEMS_PAGE_SIZE = exports.CHANGE_WON_ITEMS_PAGE = exports.LOAD_WON_ITEMS_SUCCESS = exports.LOAD_WON_ITEMS_REQUEST = exports.LOAD_WON_ITEMS_FAIL = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _user = require('../modules/user');

var _api = require('../api');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = require('reselect');

var _config = require('../modules/config');

var _ms = require('ms');

var _ms2 = _interopRequireDefault(_ms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_WON_ITEMS_FAIL = exports.LOAD_WON_ITEMS_FAIL = 'la/ui/wonItems/LOAD_FAIL';
var LOAD_WON_ITEMS_REQUEST = exports.LOAD_WON_ITEMS_REQUEST = 'la/ui/wonItems/LOAD_REQUEST';
var LOAD_WON_ITEMS_SUCCESS = exports.LOAD_WON_ITEMS_SUCCESS = 'la/ui/wonItems/LOAD_SUCCESS';
var CHANGE_WON_ITEMS_PAGE = exports.CHANGE_WON_ITEMS_PAGE = 'la/ui/wonItems/CHANGE_WON_ITEMS_PAGE';
var CHANGE_WON_ITEMS_PAGE_SIZE = exports.CHANGE_WON_ITEMS_PAGE_SIZE = 'la/ui/wonItems/CHANGE_WON_ITEMS_PAGE_SIZE';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    items: [],
    loaded: null,
    loading: false,
    page: 1,
    pageSize: 10,
    totalItems: 0
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case LOAD_WON_ITEMS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: false
            });
        case LOAD_WON_ITEMS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: true
            });
        case LOAD_WON_ITEMS_SUCCESS:
            return (0, _extends3.default)({}, state, {
                items: (0, _cloneDeep2.default)(action.payload.catalogs),
                loaded: action.meta.actionTime,
                loading: false,
                totalItems: action.payload.count
            });
        case CHANGE_WON_ITEMS_PAGE_SIZE:
            return (0, _extends3.default)({}, state, {
                pageSize: action.payload
            });
        case CHANGE_WON_ITEMS_PAGE:
            return (0, _extends3.default)({}, state, {
                page: action.payload
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.wonItems;
};

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});
var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var getTotalWonItemsCount = exports.getTotalWonItemsCount = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.totalItems;
}) || 0;
var getWonItems = exports.getWonItems = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.items;
}) || [];
var getWonItemsPage = exports.getWonItemsPage = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.page;
}) || 1;
var getWonItemsPageSize = exports.getWonItemsPageSize = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.pageSize;
}) || 10;
var areWonItemsLoaded = exports.areWonItemsLoaded = loadedSelector;

var shouldFetchWonItems = (0, _reselect.createSelector)([loadedSelector, loadingSelector], function (loaded, loading) {
    if (loaded) {
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    return !loading;
});

/* ACTION CREATORS */
var fetchWonItemsIfNeeded = exports.fetchWonItemsIfNeeded = function fetchWonItemsIfNeeded(_ref) {
    var page = _ref.page,
        pageSize = _ref.pageSize;
    return function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            state = getState();

                            if (!shouldFetchWonItems(state)) {
                                _context.next = 8;
                                break;
                            }

                            page = page || getWonItemsPage(state);
                            pageSize = pageSize || getWonItemsPageSize(state);
                            _context.next = 6;
                            return changeWonItemsPage({ force: true, page: page, pageSize: pageSize })(dispatch, getState);

                        case 6:
                            _context.next = 9;
                            break;

                        case 8:
                            return _context.abrupt('return', _promise2.default.resolve());

                        case 9:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined);
        }));

        return function (_x3, _x4) {
            return _ref2.apply(this, arguments);
        };
    }();
};

var changeWonItemsPage = exports.changeWonItemsPage = function changeWonItemsPage(_ref3) {
    var page = _ref3.page,
        pageSize = _ref3.pageSize,
        force = _ref3.force;
    return function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
            var state, oldPage, oldPageSize, dirty, authToken, deployment, bidderId, response;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            state = getState();
                            oldPage = getWonItemsPage(state);
                            oldPageSize = getWonItemsPageSize(state);
                            dirty = false;


                            if (oldPage !== page) {
                                dirty = true;
                                dispatch({
                                    payload: Number(page),
                                    type: CHANGE_WON_ITEMS_PAGE
                                });
                            }

                            if (oldPageSize !== pageSize) {
                                dirty = true;
                                dispatch({
                                    payload: Number(pageSize),
                                    type: CHANGE_WON_ITEMS_PAGE_SIZE
                                });
                            }

                            if (!(dirty || force)) {
                                _context2.next = 21;
                                break;
                            }

                            _context2.prev = 7;
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);
                            bidderId = (0, _user.getBidderId)(state);


                            dispatch({
                                meta: { actionTime: Date.now() },
                                type: LOAD_WON_ITEMS_REQUEST
                            });
                            _context2.next = 14;
                            return _api.WonItems.fetchWonItems({ authToken: authToken, bidderId: bidderId, deployment: deployment, page: page, pageSize: pageSize });

                        case 14:
                            response = _context2.sent;

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: response.data,
                                type: LOAD_WON_ITEMS_SUCCESS
                            });
                            _context2.next = 21;
                            break;

                        case 18:
                            _context2.prev = 18;
                            _context2.t0 = _context2['catch'](7);

                            dispatch({
                                error: true,
                                payload: _context2.t0,
                                type: LOAD_WON_ITEMS_FAIL
                            });

                        case 21:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, undefined, [[7, 18]]);
        }));

        return function (_x5, _x6) {
            return _ref4.apply(this, arguments);
        };
    }();
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/wonItems.js
// module id = V13H
// module chunks = 57